import {
  CSS_FONT_KEYWORDS,
  DEFAULT_NOTICE_FONT_ID,
  INHERIT_FONT_FAMILY,
  NOTICE_FONT_CATALOGUE,
  NOTICE_FONT_CSS,
  NOTICE_FONT_GENERIC_FALLBACK,
  NOTICE_FONT_STYLE_ID,
  UNSAFE_FONT_CHARACTERS,
} from "../constants";
import type { NoticeFontEntry, NoticeFontSources } from "../types";

const entryById = (id: string): NoticeFontEntry | undefined =>
  NOTICE_FONT_CATALOGUE.find((entry) => entry.id === id);

const toFontFamilyValue = (value: string): string => {
  if (value.includes(",")) {
    return value;
  }
  const family = value.replace(UNSAFE_FONT_CHARACTERS, "").trim();
  if (!family) {
    return INHERIT_FONT_FAMILY;
  }
  const lowered = family.toLowerCase();
  if (CSS_FONT_KEYWORDS.includes(lowered)) {
    return lowered;
  }
  return entryById(lowered)?.stack ?? `"${family}"${NOTICE_FONT_GENERIC_FALLBACK}`;
};

const toNoticeFontEntry = (
  fontPreference?: string
): NoticeFontEntry | undefined => {
  const stored = fontPreference?.trim();
  if (!stored) {
    return undefined;
  }
  return entryById(stored.toLowerCase()) ?? entryById(DEFAULT_NOTICE_FONT_ID);
};

export const resolveNoticeFontFamily = ({
  hostFont,
  noticeFont,
}: NoticeFontSources): string => {
  const host = hostFont?.trim();
  if (host) {
    return toFontFamilyValue(host);
  }
  return toNoticeFontEntry(noticeFont)?.stack ?? INHERIT_FONT_FAMILY;
};

export const injectNoticeFontStyles = (root: ShadowRoot | Document): void => {
  const existing =
    root instanceof Document
      ? root.getElementById(NOTICE_FONT_STYLE_ID)
      : root.querySelector(`#${NOTICE_FONT_STYLE_ID}`);
  if (existing) return;

  const style = document.createElement("style");
  style.id = NOTICE_FONT_STYLE_ID;
  style.textContent = NOTICE_FONT_CSS;
  (root instanceof Document ? root.head : root).appendChild(style);
};
